import React, { useEffect, useState, useMemo, useRef } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';
import Select from 'react-select';
import InputPDF from "components/Input/InputPDF";


// reactstrap components
import { Button, Card, CardBody, FormGroup, Form, Input, Row, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

// leaflet
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet'
import L from 'leaflet';

// style
import "assets/css/loading.css";
import "assets/css/map.css";
import { table_translate, table_style } from "constants/MaterialTable.js";

// services
import { InputCEP } from "services/mask.js";
import { showMessage, showQuestion } from "services/message.js";
import { api_GET, api_POST, api_GETExternal } from "services/api_service.js";
import { getSessionCookie } from "services/session.js";
import { EnviaProtocoloGeradorLocal, EnviaRequerimentoGeradorLocal } from "services/protocolo_gerador_service.js";
import { GetCEPViaCEP } from "services/viaCep";
import { InputCNPJ } from "services/mask";

function initialStateContratos() {
    return {
        modalidadeColeta: "",
        transportador_CNPJ: "",
        transportador_RazaoSocial: "Selecione transportador",
        arquivoContrato: null
    }
}

export default function LocaisColeta({ item, tipoCadastro, permiteManutencao, handleProximoStep, handleStepAnterior }) {
    const { register, handleSubmit, errors, setError, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });
    let session = getSessionCookie();
    const [showLoading, setshowLoading] = useState(false);

    const [registro, set_registro] = useState(null);

    const [locais_Coleta, set_locais_Coleta] = useState([]);
    const [setupSolicitacao, set_setupSolicitacao] = useState(null);

    const [modalOpen, set_modalOpen] = useState(false);
    const [localizacaoConfirmada, set_localizacaoConfirmada] = useState(false);

    //State para modal do contrato
    const [modalContrato, set_modalContrato] = useState(false);

    //State para criar o contrato local
    const [contratoLocal, set_contratoLocal] = useState(initialStateContratos());

    //State Para adicionar os contratos em cada local
    const [listContratoLocal, set_listcontratoLocal] = useState([]);

    //State para disabilitar o campos de contratos
    const [disabledCamposTransportador, set_disabledCamposTransportador] = useState(true);

    //State para pegar as modalidades do RGG
    const [listModalidadesRGG, set_listModalidadesRGG] = useState([]);

    //State para pegar o uf 
    const [municipio, set_municipio] = useState(null);

    //State para pegar o Hash
    const [hash, setHash] = useState("");

    const toggleModalContrato = () => {
        set_contratoLocal(initialStateContratos());
        set_disabledCamposTransportador(true);
        set_modalContrato(!modalContrato);
    };


    const loadItemProtocolo = () => {
        set_registro(item);
        if (item) {
            set_setupSolicitacao(item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao);
            if (item.protocoloGerador[0].protocoloGeradorLocais != null) {
                set_locais_Coleta(item.protocoloGerador[0].protocoloGeradorLocais);
            }
        }

        if (tipoCadastro == "Protocolo" && item && item?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao?.categoria?.sigla == "RGG") {
            set_actions([...actions, {
                icon: 'delete',
                tooltip: 'Remover Local',
                onClick: (event, rowData) => handleRemove(rowData)
            }]);
        }
    }


    const loadItemRequerimento = () => {
        set_registro(item);
        if (item) {

            set_setupSolicitacao(item.setupSolicitacaoAcao.setupSolicitacao);

            if (item.requerimentoGeradorLocal != null) {
                set_locais_Coleta(item.requerimentoGeradorLocal);
            }
        }
        if (tipoCadastro == "Requerimento") {
            let _action = actions;
            _action.push({
                icon: 'delete',
                tooltip: 'Remover Local',
                onClick: (event, rowData) => handleRemove(rowData)
            });

            set_actions(_action);
        }
    }

    const loadMunicipio = () => {
        setshowLoading(true);
        api_GET('SetupGeral/GetMunicipio').then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_municipio(result.data);
            }
        });
    }

    useEffect(() => {
        if (tipoCadastro == "Protocolo")
            loadItemProtocolo();
        else if (tipoCadastro == "Requerimento")
            loadItemRequerimento();

        loadMunicipio();
        loadTransportadoresRGG();
    }, []);

    // Material-Table > Actions
    const [actions, set_actions] = useState([
        {
            icon: 'edit',
            tooltip: 'Editar Registro',
            onClick: (event, rowData) => handleEdit(rowData)
        }
    ]);

    // CEP    
    const [cep, set_cep] = useState("");
    const [editarEndereco, set_editarEndereco] = useState(true);
    const [editarEnderecoCep, set_editarEnderecoCep] = useState(false);
    const handleCEP = (event) => {
        set_cep(event.target.value);

        if (event.target.value.replaceAll("_", "").length != 9)
            return;

        clearErrors("cep");

        GetCEPViaCEP(event.target.value).then(result => {
            if (result.status !== 200 || (result.data.hasOwnProperty('erro') && result.data.erro == true)) {
                showMessage("Aviso", "Cep não localizado", 'warning', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
                setValue("uf", "");
            }
            else {
                if (municipio != null && municipio != result.data.localidade) {
                    set_cep("");
                    showMessage("Aviso", `CEP não pertence a ${municipio}`, 'warning', null);
                    return;
                }

                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
                setValue("uf", result.data.uf);

                if (result.data.logradouro == null || result.data.logradouro.length == 0)
                    set_editarEndereco(false);
                else {
                    set_editarEndereco(true);

                    if (setupSolicitacao.categoria.sigla == "RSS" || setupSolicitacao.categoria.sigla == "RGG") {
                        let chave = result.data.logradouro.replaceAll(" ", "+") + "," + result.data.bairro.replaceAll(" ", "+") + result.data.localidade.replaceAll(" ", "+");
                        UpdatePositionEndereco(chave);
                    }
                }
            }
        });
    }

    const handleNumeroChange = (value) => {
        if (setupSolicitacao.categoria.sigla == "RSS" || setupSolicitacao.categoria.sigla == "RGG") {
            let data = getValues();
            let chave = data.logradouro.replaceAll(" ", "+") + "," + value + "," + data.bairro.replaceAll(" ", "+") + data.cidade.replaceAll(" ", "+");
            UpdatePositionEndereco(chave);
        }
    }

    const UpdatePositionEndereco = (chave) => {
        setshowLoading(true);
        var url = `https://maps.googleapis.com/maps/api/geocode/json?new_forward_geocoder=true&address=${chave}&key=AIzaSyBo2Y9Gr1UakCHwOfmyS_TM2K24_eTLvpk`
        api_GETExternal(url).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'error', null);
            }
            else {
                try {
                    setCenterMap([result.data.results[0].geometry.location.lat, result.data.results[0].geometry.location.lng]);
                    setpositionMarker([result.data.results[0].geometry.location.lat, result.data.results[0].geometry.location.lng]);
                }
                catch {
                    showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'error', null);
                }
            }
        });
    }

    // Mapa    
    const [centerMap, setCenterMap] = useState([0, 0]);
    const [positionMarker, setpositionMarker] = useState([0, 0]);
    const iconMarker = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png',
        iconRetinaUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png',
    });
    const markerRef = useRef(null)
    const handleMarkerPosition = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    let position = marker.getLatLng();
                    setpositionMarker([position.lat, position.lng]);
                }
            },
        }),
        [],
    )

    const ChangeMap = ({ center, zoom }) => {
        const mapInstance = useMap();
        mapInstance.setView(center, zoom);
        return null;
    }

    const handleModalClose = () => {
        set_modalOpen(false);
        set_localizacaoConfirmada(true);
    }

    const [rowEdit, set_rowEdit] = useState(null);
    const handleEdit = (rowData) => {
        set_listcontratoLocal([]);
        if (rowData?.protocoloGeradorLocalContratos?.length > 0) {
            set_listcontratoLocal(rowData.protocoloGeradorLocalContratos)
        }
        if (rowData?.requerimentoGeradorLocalContratos?.length > 0) {
            set_listcontratoLocal(rowData?.requerimentoGeradorLocalContratos);
        }
        set_editarEnderecoCep(true)
        set_localizacaoConfirmada(false);
        set_rowEdit(rowData);
        set_cep(rowData.cep);
        setValue("cep", rowData.cep);
        setValue("logradouro", rowData.logradouro);
        setValue("numEndereco", rowData.numEndereco);
        setValue("complemento", rowData.complemento);
        setValue("bairro", rowData.bairro);
        setValue("cidade", rowData.cidade);
        setValue("uf", rowData.uf);
        setHash(rowData.hash);

        if (rowData.geoLocalizacao && rowData.geoLocalizacao.split(";").length > 1) {
            setCenterMap([rowData.geoLocalizacao.split(";")[0], rowData.geoLocalizacao.split(";")[1]]);
            setpositionMarker([rowData.geoLocalizacao.split(";")[0], rowData.geoLocalizacao.split(";")[1]]);
        }
    }

    const handleRemove = (rowData) => {
        if (!permiteManutencao && tipoCadastro == "Protocolo" && setupSolicitacao.categoria.sigla != "RGG") {
            showMessage("Aviso", "Não permitida a manutenção do cadastro.", 'error', null);
            return;
        }

        let message = "Deseja remover este local?";
        if (item && item?.setupSolicitacaoAcao?.setupSolicitacao?.categoria?.sigla == "RGG")
            message = "Tem certeza que quer excluir o endereço? Seu contrato com o transportador será desfeito no Sistema de Gestão de Gadastros e no Sistema RGG."

        showQuestion('Atenção', message, 'question', function (result) {
            if (result) {
                setshowLoading(true);
                if (tipoCadastro == "Requerimento") {
                    api_POST('requerimentoGerador/PostRemoverGeradorLocalRequerimento/' + rowData.requerimentoGeradorLocal_Id).then(result => {
                        setshowLoading(false);
                        if (result.status !== 200)
                            showMessage("Aviso", result.message, 'error', null);
                        else {
                            showMessage("Aviso", "Local removido com sucesso!", 'success', function () {
                                handleReturnRemove(rowData.requerimento_Id);
                            });
                        }
                    });
                } else if (tipoCadastro == "Protocolo") {
                    api_POST('protocoloGerador/PostRemoverGeradorLocalProtocolo/' + rowData.protocoloGeradorLocal_Id).then(result => {
                        setshowLoading(false);
                        if (result.status !== 200)
                            showMessage("Aviso", result.message, 'error', null);
                        else {
                            showMessage("Aviso", "Local removido com sucesso!", 'success', null);
                            set_locais_Coleta(item.protocoloGerador[0].protocoloGeradorLocais.filter(x => x.protocoloGeradorLocal_Id != rowData.protocoloGeradorLocal_Id))
                        }
                    });
                }
            }
        })
    }
    const handleReturnRemove = (reloadId) => {
        setshowLoading(true);
        api_GET('requerimentoGerador/GetLocaisRequerimentoGerador/' + reloadId).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_locais_Coleta(result.data);
            }
        });
    }

    const onSubmit = (data) => {
        if (rowEdit == null && locais_Coleta.filter(f => f.cEP == data.cep && f.numEndereco == data.numEndereco).length > 0) {
            showMessage("Aviso", "Já existe um local de coleta neste endereço!", 'error', null);
            return;
        }

        if (setupSolicitacao.categoria.sigla == "RGG" && listContratoLocal.length == 0) {
            showMessage("Aviso", "Para salvar um local de coleta, deve ser obrigatório informar pelo menos 1 contrato.", 'error', null);
            return;
        }

        if ((setupSolicitacao.categoria.sigla == "RSS" || setupSolicitacao.categoria.sigla == "RGG") && !localizacaoConfirmada) {
            set_modalOpen(true);
            return;
        }

        setshowLoading(true);
        if (permiteManutencao && tipoCadastro == "Protocolo") {
            let json = carregaJsonProtocolo(data);
            EnviaProtocoloGeradorLocal(json, confirmaAddLocaisColeta)
        }
        else if (tipoCadastro == "Requerimento") {
            let json = carregaJsonRequerimento(data);
            EnviaRequerimentoGeradorLocal(json, confirmaAddLocaisColeta)
        }
    }

    const carregaJsonProtocolo = (data) => {
        let _listContratoLocal = [];
        if (listContratoLocal.length > 0) {
            listContratoLocal.map(value => {
                _listContratoLocal.push({
                    ...value,
                    modalidadeColeta: value.modalidadeColeta,
                    transportador_CNPJ: value.transportador_CNPJ,
                    transportador_RazaoSocial: value.transportador_RazaoSocial,
                    arquivoContrato: value.arquivoContrato?.base64 ?? value.arquivoContrato
                })
            });
        }

        let json_submit = {
            protocoloGeradorLocal_Id: rowEdit == null ? 0 : rowEdit.protocoloGeradorLocal_Id,
            protocoloGerador_Id: item.protocoloGerador[0].protocoloGerador_Id,
            cEP: data.cep.replace(/[^0-9]/g, ''),
            logradouro: data.logradouro,
            numEndereco: data.numEndereco,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            geoLocalizacao: setupSolicitacao.categoria.sigla == "RSS" || setupSolicitacao.categoria.sigla == "RGG" ? positionMarker[0] + ";" + positionMarker[1] : null,
            status: "Ativo",
            usuarioUltimaAlteracao_Id: session != null ? session.usuario_Id : null,
            protocoloGeradorLocalContratos: _listContratoLocal
        }
        return json_submit;
    }

    const carregaJsonRequerimento = (data) => {
        let _listContratoLocal = [];
        if (listContratoLocal.length > 0) {
            listContratoLocal.map(value => {
                _listContratoLocal.push({
                    ...value,
                    modalidadeColeta: value.modalidadeColeta,
                    transportador_CNPJ: value.transportador_CNPJ,
                    transportador_RazaoSocial: value.transportador_RazaoSocial,
                    arquivoContrato: value.arquivoContrato?.base64 ?? value.arquivoContrato
                })
            });
        }

        let json_submit = {
            requerimentoGeradorLocal_Id: rowEdit == null ? 0 : rowEdit.requerimentoGeradorLocal_Id,
            requerimento_Id: item.requerimento_Id,
            cEP: data.cep.replace(/[^0-9]/g, ''),
            logradouro: data.logradouro,
            numEndereco: data.numEndereco,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            geoLocalizacao: setupSolicitacao.categoria.sigla == "RSS" || setupSolicitacao.categoria.sigla == "RGG" ? positionMarker[0] + ";" + positionMarker[1] : null,
            status: "Ativo",
            usuarioUltimaAlteracao_Id: session != null ? session.usuario_Id : null,
            requerimentoGeradorLocalContratos: _listContratoLocal
        }

        return json_submit;
    }

    const confirmaAddLocaisColeta = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
            return;
        }

        let local = result.data;

        let new_list = [];

        let _registro = registro;
        if (tipoCadastro == "Protocolo") {
            locais_Coleta.map(m => {
                if (m.protocoloGeradorLocal_Id != local.protocoloGeradorLocal_Id)
                    new_list.push(m);
            });

            _registro.protocoloGerador[0].protocoloGeradorLocais = new_list;
        }
        else if (tipoCadastro == "Requerimento") {
            locais_Coleta.map(m => {
                if (m.requerimentoGeradorLocal_Id != local.requerimentoGeradorLocal_Id)
                    new_list.push(m);
            });

            _registro.requerimentoGeradorLocal = new_list;
        }

        new_list.push(local);
        set_locais_Coleta(new_list);
        set_registro(_registro);

        set_cep("");
        setValue("cep", "");
        setValue("logradouro", "");
        setValue("numEndereco", "");
        setValue("complemento", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");

        set_rowEdit(null);
        set_listcontratoLocal([]);
        showMessage("Aviso", "Operação executada com sucesso", 'success', null);
    }

    const loadModalidadesRGG = () => {
        api_GET('RGG/GetListModalidadesAtivasRGG').then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_listModalidadesRGG(result.data);
            }
        });
    }

    const [listaTransportadoresRGG, setListaTransportadoresRGG] = useState([]);
    const loadTransportadoresRGG = () => {

        api_GET('ProtocoloTransportador/GetListTransportadoresRGG').then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                result.data.map(value => {
                    value.value = value.razaoSocial;
                    value.label = value.razaoSocial;
                    return value;
                })
                setListaTransportadoresRGG([{ value: "Selecione transportador", label: "Selecione transportador" }, ...result.data])
            }
        });
    }

    const handleRemoveContratoLocal = (rowData) => {
        set_listcontratoLocal(listContratoLocal.filter((x, index) => x.modalidadeColeta != rowData.modalidadeColeta && index != rowData.tableData.id));
    }

    const validadoContratoLocal = () => {
        if (contratoLocal?.modalidadeColeta?.length == 0) {
            showMessage("Aviso", "Informe a modalidade do contrato.", 'error', null);
            return;
        }

        if (contratoLocal?.transportador_RazaoSocial == "Selecione transportador") {
            showMessage("Aviso", "Selecione o transportador por favor.", 'error', null);
            return;
        }

        if (contratoLocal?.arquivoContrato == null || contratoLocal?.arquivoContrato?.length == 0) {
            showMessage("Aviso", "Por favor adicione o arquivo do contrato.", 'error', null);
            return;
        }

        if (listContratoLocal.length > 0 && listContratoLocal.filter(x => x.modalidadeColeta == contratoLocal?.modalidadeColeta).length > 0) {
            showMessage("Aviso", "Essa modalidade já existe, por favor selecione uma diferente.", 'error', null);
            return;
        }

        if (contratoLocal.tableData) {
            set_listcontratoLocal(listContratoLocal.map((value, index) => {
                if (index == contratoLocal.tableData.id) {
                    const { tableData, ..._contratoLocal } = contratoLocal;
                    return _contratoLocal;
                } else {
                    return value;
                }
            }));
        } else {
            set_listcontratoLocal([...listContratoLocal, contratoLocal]);
        }

        set_contratoLocal(initialStateContratos());
        set_disabledCamposTransportador(true);
    }

    const handleTransportador = (cnpj) => {
        const [transportador] = listaTransportadoresRGG.filter(t => t.cnpj == cnpj);

        if (!transportador) {
            showMessage("Aviso", "Selecione um transportador por favor!", "warning", null);
            return;
        }

        if (!!transportador) {
            set_disabledCamposTransportador(false);
            set_contratoLocal({
                ...contratoLocal,
                transportador_CNPJ: transportador.cnpj,
                transportador_RazaoSocial: transportador.razaoSocial,
            });
        }
    }

    const handleAvancar = () => {
        if (setupSolicitacao.categoria.sigla == "RGG" && rowEdit != null) {
            showMessage("Aviso", "Para prosseguir, Salve as alterações em Salvar Local", "warning", null);
            return;
        }
        if (session == null && locais_Coleta.length == 0 && (setupSolicitacao.categoria.sigla != "RSS" || setupSolicitacao.categoria.sigla != "RGG")) {
            showMessage("Aviso", "Você não pode avançar sem informar os locais de coleta", 'error', null);
            return;
        }

        handleProximoStep(registro);
    }

    const closeBtn = (
        <Button
            color="danger"
            className="rtext-center text-white"
            onClick={toggleModalContrato}
            type="button"
            style={{ borderRadius: "50%" }}
        >
            x
        </Button>
    );

    return (
        <>
            <div>
                {showLoading &&
                    <div className="carregandoCmp">
                        <div className="box">
                            <img src={require("assets/img/loading.gif")}></img>
                        </div>
                    </div>
                }
                <Card className={`card-stats`}>
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Locais de Coleta</h2>
                            <div className="formPrincipal">
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    {item &&
                                        (item?.setupSolicitacaoAcao?.acao == "Alteração" || item?.setupSolicitacaoAcao?.acao == "Renovação") &&
                                        (setupSolicitacao && setupSolicitacao.categoria.sigla == "RGG") &&
                                        <Row className="mb-2">
                                            <Col lg={12}>
                                                <span className="text-danger">* Para alterar um contrato de coleta, clique em editar o endereço e em seguida em “Contratos”.</span>
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label>CEP</label></b>
                                                <InputCEP
                                                    name="cep"
                                                    onChange={handleCEP}
                                                    readOnly={editarEnderecoCep}
                                                    value={cep}
                                                    inputRef={register({ required: session && session != null ? false : true })}
                                                />
                                                {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="5" lg="5">
                                            <FormGroup>
                                                <b><label>Logradouro</label></b>
                                                <Input
                                                    type="text"
                                                    name="logradouro"
                                                    readOnly={editarEndereco}
                                                    maxLength="100"
                                                    innerRef={register({ required: session && session != null ? false : true })}
                                                />
                                                {errors.logradouro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label>Bairro</label></b>
                                                <Input
                                                    type="text"
                                                    name="bairro"
                                                    readOnly={editarEndereco}
                                                    maxLength="50"
                                                    innerRef={register({ required: session && session != null ? false : true })}
                                                />
                                                {errors.bairro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <b><label>Número</label></b>
                                                <Input
                                                    type="number"
                                                    name="numEndereco"
                                                    maxLength="10"
                                                    innerRef={register({ required: session && session != null ? false : true })}
                                                    onBlur={(e) => handleNumeroChange(e.target.value)}
                                                />
                                                {errors.numEndereco && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label>Complemento</label></b>
                                                <Input
                                                    type="text"
                                                    name="complemento"
                                                    maxLength="50"
                                                    innerRef={register({ required: session && session != null || (setupSolicitacao && setupSolicitacao.categoria.sigla == "RGG") ? false : true })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label>Cidade</label></b>
                                                <Input
                                                    type="text"
                                                    name="cidade"
                                                    readonly="readonly"
                                                    maxLength="50"
                                                    innerRef={register({ required: session && session != null ? false : true })}
                                                />
                                                {errors.cidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="1" lg="1">
                                            <FormGroup>
                                                <b><label>UF</label></b>
                                                <Input
                                                    type="text"
                                                    name="uf"
                                                    readonly="readonly"
                                                    innerRef={register({ required: session && session != null ? false : true })}
                                                />
                                                {errors.uf && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        {setupSolicitacao && (setupSolicitacao.categoria.sigla == "RSS" || setupSolicitacao.categoria.sigla == "RGG") &&
                                            <Col md="1" lg="1">
                                                <Button
                                                    color="info"
                                                    className="btn-mobile"
                                                    type="button"
                                                    onClick={() => set_modalOpen(true)}><i className="fas fa-map-marked-alt"></i>
                                                </Button>
                                            </Col>
                                        }
                                    </Row>
                                    {!!hash && session?.usuario_Id != null &&
                                        <Row>
                                            <Col md="5" lg="5">
                                                <>
                                                    <b><label>Hash: </label></b> <label>{hash}</label>
                                                </>
                                            </Col>
                                        </Row>
                                    }
                                    <div className="d-flex justify-content-center align-items-center gap-3">
                                        {setupSolicitacao?.categoria?.sigla == "RGG" &&
                                            <Button
                                                color="primary"
                                                className="btn-mobile"
                                                onClick={() => {
                                                    loadModalidadesRGG();
                                                    set_modalContrato(true)
                                                }}
                                            >
                                                <i className="fas fa-file-alt"></i> Contratos
                                            </Button>
                                        }
                                        <Button
                                            color="success"
                                            className="btn-mobile"
                                            type="submit">
                                            <i className="fas fa-save"> </i> Salvar Local
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                            <Row>
                                <Col md="12">
                                    <MaterialTable style={{ minHeight: "auto" }}
                                        title=""
                                        columns={[
                                            { title: 'CEP', field: 'cep' },
                                            { title: 'Logradouro', field: 'logradouro' },
                                            { title: 'Número', field: 'numEndereco' },
                                            { title: 'Complemento', field: 'complemento' },
                                            { title: 'Bairro', field: 'bairro' },
                                            { title: 'Cidade', field: 'cidade' },
                                            { title: 'UF', field: 'uf' }
                                        ]}
                                        data={locais_Coleta}
                                        isLoading={false}
                                        actions={actions}
                                        localization={table_translate}
                                        options={table_style}
                                    />
                                </Col>
                                <Col lg="6" className="text-left">
                                    <Button color="secundary"
                                        onClick={() => handleStepAnterior(registro)}
                                        className="btn-mobile"
                                        type="submit">
                                        <i className="fas fa-chevron-left"></i>
                                        Voltar
                                    </Button>
                                </Col>
                                <Col lg="6" className="text-right">
                                    <Button
                                        color="success"
                                        onClick={handleAvancar}
                                        className="btn-mobile"
                                        type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i>
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </CardBody>
                </Card>
            </div>

            {/* mostrar Contrato */}
            <Modal
                centered
                isOpen={modalContrato}
                toggle={toggleModalContrato}
                size={"xl"}
                close={closeBtn}
                style={{ marginTop: "70px" }}
            >
                <ModalBody className="pt-1">
                    <ModalHeader
                        toggle={toggleModalContrato}
                        close={closeBtn}
                        className="p-0 m-0 d-flex align-items-center"
                        style={{ borderBottom: "none" }}
                    >
                        Contratos
                    </ModalHeader>
                    <Row>
                        <Col lg="5">
                            <FormGroup>
                                <b><label>Modalidade</label></b>
                                <Select
                                    options={listModalidadesRGG.map(value => { return { value: value.descricao, label: value.descricao } })}
                                    name="modalidadeColeta "
                                    value={listModalidadesRGG.map(value => { return { value: value.descricao, label: value.descricao } }).find(obj => obj.value === contratoLocal?.modalidadeColeta)}
                                    onChange={(value) => {
                                        set_contratoLocal({
                                            ...contratoLocal,
                                            ["modalidadeColeta"]: value.value
                                        })
                                    }}
                                    placeholder="Selecione"
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="5">
                            <FormGroup>
                                <b><label>Transportadores</label></b>
                                <Select
                                    options={listaTransportadoresRGG}
                                    name="transportador_CNPJ"
                                    onChange={(e) => { handleTransportador(e.cnpj) }}
                                    value={listaTransportadoresRGG.find(obj => obj.value === contratoLocal?.transportador_RazaoSocial)}
                                    placeholder="Selecione"
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="2" className="d-flex flex-column justify-content-center align-items-center">
                            <b><label>Arquivo Contrato</label></b>
                            <FormGroup>
                                <InputPDF
                                    height="4rem"
                                    width="4rem"
                                    image={contratoLocal?.arquivoContrato}
                                    name={"arquivoContrato"}
                                    handlefile={(file) => set_contratoLocal({ ...contratoLocal, ["arquivoContrato"]: { base64: file.base64 } })}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="12" className="d-flex flex-column justify-content-center align-items-center">
                            <Button
                                color="success"
                                className={"text-center"}
                                onClick={validadoContratoLocal}
                            >
                                Confirmar
                            </Button>
                        </Col>
                        <Col md="12">
                            <MaterialTable style={{ minHeight: "auto", zIndex: 0 }}
                                title=""
                                columns={[
                                    { title: 'Modalidade', field: 'modalidadeColeta' },
                                    { title: 'CNPJ', field: 'transportador_CNPJ' },
                                    { title: 'Razão Social', field: 'transportador_RazaoSocial' }
                                ]}
                                data={listContratoLocal}
                                isLoading={false}
                                actions={[
                                    {
                                        icon: 'delete',
                                        tooltip: 'deletar Registro',
                                        onClick: (event, rowData) => handleRemoveContratoLocal(rowData)
                                    }]}
                                localization={table_translate}
                                options={table_style}
                            />
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>

            {/* mostrar mapa */}
            <Modal
                centered
                isOpen={modalOpen}
                toggle={handleModalClose}
                zIndex="9999999"
            >
                <ModalBody className="md-bd">
                    <h6>Confirme o Local no Mapa</h6>
                    <Row className="mt-2">
                        <Col lg="12">
                            <div id="map">
                                <MapContainer style={{ zIndex: "0" }} >
                                    <ChangeMap center={centerMap} zoom={20}></ChangeMap>
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        opacity={0.5}
                                    />
                                    <Marker
                                        position={positionMarker}
                                        draggable={true}
                                        icon={iconMarker}
                                        ref={markerRef}
                                        eventHandlers={handleMarkerPosition}
                                    />
                                </MapContainer>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="md-ft">
                    <Button
                        color="secondary"
                        outline
                        onClick={handleModalClose}
                    >
                        Confirmar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}